import { Component, EventEmitter, OnDestroy, OnInit, Output, ChangeDetectionStrategy, ChangeDetectorRef, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subscription } from 'rxjs';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { F4255PartIService } from './f4255-part-i.service';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  buildHeaderDataShell,
  generalConfigFromGlobal,
  normalizeFilterParams,
  rowPayloadFromActiveScreen
} from '../../../shared/workspace-element-context';

@Component({
    selector: 'gtw-f4255-part-i',
    templateUrl: './f4255-part-i.component.html',
    styleUrls: ['./f4255-part-i.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class F4255PartIComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);


  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  private readonly subs = new Subscription();
  private isInitialized = false;

  baseURLs: any = { admin: '', api: '', custom: '', efile: '', pdfEngine: '', bulkPdfEngine: '' };
  globalService: any = {};
  GENERAL_CONFIG: any = {};
  filterParams: any = {};
  rowData: any = {};

  minimise = false;
  crudLoading = false;
  showFormLoader = true;
  modalTitle = 'Form 4255 Part I';

  accounts: any[] = [];
  accounts1: any[] = [];

  constructor(
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService,
    private cdr: ChangeDetectorRef,
    private gtwSnackbarService: GtwSnackbarService,
    private f4255PartIService: F4255PartIService
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(this.gtwWorkspace.setTabActive.subscribe(() => {
      this.applyWorkspaceContext();
      this.tryInit();
    }));
    this.subs.add(this.gtwGlobal.globalParamsChanged$.subscribe(() => {
      this.applyWorkspaceContext();
      this.tryInit();
    }));
    this.tryInit();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    this.globalService = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    this.baseURLs = generalConfigFromGlobal(this.gtwGlobal);
    this.GENERAL_CONFIG = this.globalService.generalConfigData || {};
    this.filterParams = normalizeFilterParams(activeScreen);
    this.rowData = rowPayloadFromActiveScreen(activeScreen);
    this.cdr.detectChanges();
  }

  private tryInit() {
    if (this.isInitialized) return;
    if (!this.GENERAL_CONFIG || !this.rowData || Object.keys(this.rowData).length === 0) return;
    this.isInitialized = true;
    this.init();
  }

  private init() {
    this.loadData();
  }

  private loadData() {
    const params: any = {
      action_code: 'zmfcge',
      tax_year: this.rowData.TAX_YEAR ?? this.filterParams?.tax_year ?? this.globalService?.globalParams?.tax_year,
      scenario: this.rowData.SCENARIO ?? this.filterParams?.scenario ?? this.globalService?.globalParams?.scenario,
      jcd_key: this.rowData.JCD_KEY ?? this.filterParams?.jcd_key ?? this.globalService?.globalParams?.jcd_key ?? 250
    };

    this.f4255PartIService.loadJsonObject(this.GENERAL_CONFIG.base_url, params).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (data: any) => {
        if (data.jsonObject) {
          this.accounts = data.jsonObject;
          this.accounts1 = [...(data.jsonObject || [])];
        }
        this.showFormLoader = false;
        this.cdr.detectChanges();
      },
      (err: any) => {
        console.error('Error loading F4255 Part I data:', err);
        this.showFormLoader = false;
        this.cdr.detectChanges();
      }
    );
  }

  reset() {
    this.loadData();
  }

  cancel() {
    this.requestGridUpdate.emit('cancel');
  }
}
